import React from "react";
import "./src/styles/global.scss";
import { Toaster } from "react-hot-toast";
import { AlertBannerProvider } from "./src/lib/contexts/alertBannerContext";

export const wrapRootElement = ({ element }) => {
  return (
    <AlertBannerProvider>
      {element}
      <Toaster 
        position="top-right"
        containerStyle={{
          zIndex: 1000000,
        }}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#333',
            color: '#fff',
            borderRadius: '10px',
            fontSize: '14px',
          },
        }}
      />

    </AlertBannerProvider>
  );
};


